import React from 'react';
import './HowItWorks.css';

const HowItWorks = ({ handleScheduleClick }) => {
  return (
    <div className="how-it-works-container">
      <section className="work-process-hero">
        <div className="work-process-hero-content">
          <h1 className="work-process-hero-title">
            How It Works: <span className="highlight">Simple, Honest, and Fast</span>
          </h1>
          <div className="work-process-hero-text">
            <h2>Getting Reliable Handyman Help Shouldn't Be This Hard.</h2>
            <p>We make it easy — and we mean actually easy.</p>
            <p>No more waiting for "windows" or wondering if someone will show up. Here's exactly what happens when you book with us:</p>
          </div>
        </div>
        <div className="work-process-hero-decoration">
          <div className="decoration-circle circle-1"></div>
          <div className="decoration-circle circle-2"></div>
          <div className="decoration-circle circle-3"></div>
        </div>
      </section>

      <section className="steps-section">
        <h2>Here's what you can expect when you book with Breakthrough:</h2>
        
        <div className="steps-grid">
          <div className="step-card">
            <div className="step-icon">🪛</div>
            <h3>Step 1: Tell Us What You Need</h3>
            <p>Use the chatbot, give us a call, or fill out a quick form. Just let us know what needs fixing, installing, replacing, or building.</p>
            <p className="step-note">No jargon needed — just tell us like you'd tell a friend.</p>
          </div>

          <div className="step-card">
            <div className="step-icon">📅</div>
            <h3>Step 2: Pick a Real Appointment Time</h3>
            <p>We don't do "windows." We give you a specific time and show up when we say we will.</p>
            <p className="step-note">If anything changes, you'll get a call directly from your handyman — no guessing.</p>
          </div>

          <div className="step-card">
            <div className="step-icon">💬</div>
            <h3>Step 3: Confirm Details with Your Handyman</h3>
            <p>Your handyman arrives on time, walks through the job with you, confirms scope and expectations, and gives a clear game plan before starting.</p>
          </div>

          <div className="step-card">
            <div className="step-icon">🔧</div>
            <h3>Step 4: The Work Gets Done — Efficiently & Respectfully</h3>
            <p>We stay focused, clean up after ourselves, and keep you in the loop along the way.</p>
            <p className="step-note">If anything unexpected comes up, we'll pause and explain the options before continuing.</p>
          </div>

          <div className="step-card">
            <div className="step-icon">✅</div>
            <h3>Step 5: You Approve the Work</h3>
            <p>Your handyman won't ask for payment until you've walked the job, asked questions, and are fully satisfied.</p>
            <p className="step-note">No pressure. No prepayment. Just honest work.</p>
          </div>

          <div className="step-card">
            <div className="step-icon">💳</div>
            <h3>Step 6: You Pay — Only When You're Happy</h3>
            <p>We take payment at the end — once you're smiling.</p>
            <p className="step-note">Receipts are sent immediately. If anything goes wrong later, we'll make it right.</p>
          </div>
        </div>
      </section>

      <section className="policies-section">
        <h2>⚠️ Our Policies Keep Everything Running Smoothly</h2>
        <div className="policies-grid">
          <div className="policy-card">
            <h3>Cancellation Fees</h3>
            <p>These protect the time of our full-time handymen and ensure every customer can get reliable help.</p>
          </div>
          <div className="policy-card">
            <h3>Late Fees</h3>
            <p>Handymen have 2–3 jobs per day. Being late for one affects them all — including yours.</p>
          </div>
          <div className="policy-card">
            <h3>Material Runs</h3>
            <p>If you don't have everything onsite, we're happy to shop for you — but it adds an hour for store time.</p>
          </div>
        </div>
        <p className="policies-note">These policies aren't here to nickel-and-dime. They keep things flowing for everyone.</p>
      </section>

      <section className="cta-section">
        <h2>🤖 Ask Alex to Get Started</h2>
        <p>Our smart assistant can quote, schedule, and help you 24/7.</p>
        <div className="cta-buttons">
          <button className="cta-button primary" onClick={handleScheduleClick}>
            👉 Chat Now
          </button>
          <a className="cta-button secondary" href="tel:+6029385415">
            📞 Or Call Us Directly
          </a>
        </div>
      </section>
    </div>
  );
};

export default HowItWorks; 
